import Configuration from '@/agilis/util/Configuration'
import { mapGetters } from 'vuex'
import L from 'lodash'
import jsonLogic from '@/plugins/jsonLogic'

// Mixin providing common render utils
export default {
  name: 'DataTableRenderMixin',

  props: {
    propTitle: String,
    trackerTypeConfig: Object
  },

  data () {
    return {
      itemsPerPage: 10,
      itemsPerPageOptions: [5, 10, 15, -1],
      itemDTO: {}
    }
  },

  computed: {
    ...mapGetters({
      'selectedContext': 'contextStore/selectedContext',
      'mode': 'contextStore/contextMode',
      'applicationId': 'contextStore/applicationId',
      'trackerTypeId': 'contextStore/trackerTypeId'
    }),
    caption () {
      return this.dataTableConfiguration.caption
    },
    headers () {
      return Configuration.auth.getHeaders(this.dataTableConfiguration, this.selectedContext, this.featureId)
    },
    computedViewTitle () {
      return this.filterName
    },
    computedDescription () {
      return this.description ? this.description : this.$t(this.dataTableConfiguration.descriptionLabel)
    },

    computedTitle () {
      return this.propTitle ? this.propTitle : this.$t(this.dataTableConfiguration.titleLabel)
    },

    showExpand () {
      return this.dataTableConfiguration.expandRows // && "gestirlo anche come permesso volendo"
    },

    trackerType () {
      return this.trackerTypeConfig || Configuration.getApplication(this.applicationId).trackerTypes[this.trackerTypeId]
    }
  },

  created: function () {
    this.itemsPerPage = this.dataTableConfiguration?.itemsPerPage ? this.dataTableConfiguration.itemsPerPage : 10
    this.itemsPerPageOptions = L.uniq(
      [...this.itemsPerPageOptions, this.itemsPerPage] // add itemsPerPage form config
        .sort((a, b) => (a > b ? 1 : -1)) // sort
        .filter(n => n !== -1)
        .filter(Boolean)
        .concat([-1]) // append -1 ("all")
    ) // remove duplicates
    this.itemDTO = this.setContext(Configuration.datatable.getDTO(this.dataTableConfiguration))
  },

  methods: {
    renderColumn (colId, item) {
      const colConfig = this.dataTableConfiguration.columns[colId]
      if (colConfig.computed) {
        item[colConfig.id] = jsonLogic.apply(colConfig.computed.jsonLogic, { tracker: item })
      }
      return Configuration.datatable.renderColumn(colConfig, item)
    },

    rowClasses (item) {
      if (item.__backgroundColor) {
        // For color classes, see https://vuetifyjs.com/en/styles/colors/#material-colors
        return item.__backgroundColor
      }
      return ''
    },

    decorateJsonLogicContext (item) {
      item.renderColumn = this.renderColumn
      return item
    }
  }
}
